import React, { forwardRef } from 'react';

export interface AbsFullscreenGradientBgProps {
  children?: React.ReactNode;
  zIndex: number;
  padding?: number;
  bgColor?: string;
  disableGradient?: boolean;
}

export const AbsFullscreenGradientBg = forwardRef<HTMLDivElement, AbsFullscreenGradientBgProps>(
  ({ children, zIndex, padding, disableGradient, bgColor = '#fff' }, ref) => {
    return (
      <div
        ref={ref}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: disableGradient
            ? bgColor
            : 'linear-gradient(180deg, #DBE9FF 0%, #E9FFFD 100%)',
          padding: padding || 0,
          zIndex,
        }}
      >
        {children}
      </div>
    );
  }
);

AbsFullscreenGradientBg.displayName = 'AbsFullscreenGradientBg';
